import LegalShell from "./LegalShell";

export default function Terms() {
  return (
    <LegalShell
      eyebrow="Legal · PNC UNIQUE LTD"
      title="Terms & Conditions"
      updated="February 2026"
      testid="terms-page"
    >
      <p>
        These Terms &amp; Conditions govern your use of the <strong>PNC Absence Notifications Portal</strong>
        (the &quot;Portal&quot;), operated by <strong>PNC UNIQUE LTD</strong> (&quot;PNC&quot;, &quot;we&quot;, &quot;us&quot;, &quot;our&quot;),
        Company registered in England and Wales, ICO Registration ZB865873.
      </p>

      <h2>1. Who these Terms apply to</h2>
      <p>These Terms apply to:</p>
      <ul>
        <li><strong>Contractors</strong> submitting absence notifications.</li>
        <li><strong>Supervisors</strong> reviewing, approving, rejecting or cancelling notifications.</li>
        <li><strong>Managers and administrators</strong> using the Portal to plan cover and manage the service.</li>
      </ul>

      <h2>2. Purpose of the Portal</h2>
      <p>
        The Portal exists to replace the previous Excel-based absence process. Its sole purpose is to record,
        route and audit absence notifications across PNC sites. It is not a general-purpose HR system and must
        not be used to store data unrelated to absence management.
      </p>

      <h2>3. Access &amp; credentials</h2>
      <ul>
        <li>Contractors may submit notifications through the public request form using a valid site/department code where required.</li>
        <li>Supervisors and administrators are issued named accounts and passwords. You are responsible for keeping these credentials secret.</li>
        <li>Do not share your login. If you believe your account has been compromised, contact <a href="mailto:admin@pncunique.com">admin@pncunique.com</a> immediately.</li>
      </ul>

      <h2>4. Accurate information</h2>
      <p>
        You must ensure the information you submit is truthful, accurate and up to date. Deliberately
        submitting false absence information may constitute a disciplinary matter under your contract of
        engagement.
      </p>

      <h2>5. Acceptable use</h2>
      <p>You must not:</p>
      <ul>
        <li>Attempt to access data you are not authorised to see.</li>
        <li>Interfere with the Portal&apos;s security, availability or integrity.</li>
        <li>Use the Portal to send unsolicited messages or upload malicious content.</li>
        <li>Copy, extract or redistribute personal data of other contractors.</li>
      </ul>

      <h2>6. Decisions recorded through the Portal</h2>
      <p>
        Approvals, rejections and cancellations recorded in the Portal are attributable to the named user who
        made them and are captured with timestamps for audit purposes. Decisions on absence remain governed
        by your contract of engagement and PNC&apos;s wider absence policy.
      </p>

      <h2>7. Availability</h2>
      <p>
        We aim for continuous availability but do not guarantee uninterrupted service. Planned maintenance
        will be communicated in advance where reasonably possible.
      </p>

      <h2>8. Intellectual property</h2>
      <p>
        All software, branding, layout and content in the Portal is owned by PNC UNIQUE LTD or its licensors
        and is protected by intellectual-property law. You are granted a limited, non-transferable licence to
        use the Portal solely for its intended purpose during your engagement with PNC.
      </p>

      <h2>9. Liability</h2>
      <p>
        Nothing in these Terms limits liability that cannot lawfully be limited (including for death, personal
        injury caused by negligence, or fraud). Subject to that, PNC is not liable for indirect or
        consequential losses arising from your use of the Portal.
      </p>

      <h2>10. Termination</h2>
      <p>
        We may suspend or terminate access to the Portal if you materially breach these Terms, if your
        engagement with PNC ends, or if required by law.
      </p>

      <h2>11. Governing law</h2>
      <p>
        These Terms are governed by the laws of England and Wales, and the courts of England and Wales have
        exclusive jurisdiction over any disputes.
      </p>

      <h2>12. Contact</h2>
      <p>
        Questions about these Terms should be sent to
        <a href="mailto:admin@pncunique.com"> admin@pncunique.com</a>.
      </p>
    </LegalShell>
  );
}
